import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FibrePricingResponse } from 'src/app/models/fibre-offering';

@Injectable({
  providedIn: 'root'
})
export class FibreService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    })
  };

  constructor(private http: HttpClient) { }

  getPricing$(developmentId: number): Observable<FibrePricingResponse> {
    return this.http.get<FibrePricingResponse>(
      `${environment.api.base_url}/fibre/pricing/${developmentId}`,
      this.httpOptions
    );
  }

  submit$(token: string, payload: any): Observable<{ ok: true }> {
    return this.http.post<{ ok: true }>(
      `${environment.api.base_url}/fibre/applications/${token}`,
      payload,
      this.httpOptions
    );
  }
}
